export default __webpack_public_path__ + "static/media/Rainfall_Logo1.e3771e72.svg";